import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router';
import queryString from 'query-string';

import { useApi } from './Api';
import { Context } from '../Context/Context';
import { useToast } from './Toast';
import { serverErrorHandler } from '../Utils/Helpers';
import { hasToken, removeToken, setToken } from '../Utils/Token';

export const useAuth = () => {
  const { post, get } = useApi();
  const context = useContext(Context);
  const { error, success } = useToast();
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = queryString.parse(search);

  const login = async (data, setLoaing, setServerErrors, serverErrors) => {
    setLoaing(true);
    await post(
      '/login',
      data,
      (res) => {
        success('ورود با موفقیت انجام شد.');
        setToken(res.data.token);
        setLoaing(false);
        return params?.back_url ? navigate(params?.back_url) : navigate('/');
      },
      (err) => {
        error('نام کاربری و یا کلمه عبور اشتباه است');
        if (err?.status === 422) {
          setLoaing(false);
          //   error("کد ملی و یا کلمه عبور اشتباه است");
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
        }
        setLoaing(false);
      },
    );
  };

  const authUser = async () => {
    await get(
      '/user/auth',
      (res) => {
        context.user = res.data;
      },
      (err) => {
        error('دریافت اطلاعات کاربر ناموفق بود.');
      },
    );
  };

  const logout = () => {
    removeToken('token');
    return navigate('/');
  };

  const check = () => {
    return hasToken();
  };

  return {
    login: (data, setLoaing, setServerErrors, serverErrors) =>
      login(data, setLoaing, setServerErrors, serverErrors),
    authUser: () => authUser(),
    logout: () => logout(),
    check: () => check(),
  };
};
